import React from 'react';
import { get } from 'lodash';

// React view component to render
import { authFlowVerificationPreVerifiedMembers as AuthFlowVerificationPreVerifiedMembers } from 'ui/views/widgets/authFlowVerificationPreVerifiedMembers';
import { AuthFlowVerificationPreVerifiedMembersWidgetService } from 'services/authFlowVerificationPreVerifiedMembersWidget';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import { withRouter } from 'react-router-dom';
import { GlobalService } from 'services/global';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { AuthFlowVerificationPreVerifiedMembersWidget } from 'ui/containers/AuthFlowVerificationPreVerifiedMembersWidget';
 *
 * // render
 * <AuthFlowVerificationPreVerifiedMembersWidget propName='propValue'/>
 */
export class _AuthFlowVerificationPreVerifiedMembersWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // bind events and methods
        this.handleOnClickAction = this.handleOnClickAction.bind( this );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // create service instance
        this.authFlowVerificationPreVerifiedMembersWidgetService = new AuthFlowVerificationPreVerifiedMembersWidgetService();
        this.globalService = new GlobalService();
        
        // start component data fetch
        this.fetchComponentData();
    }

    /*********************************************/

    /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( 'AuthFlowVerificationPreVerifiedMembers.fetchComponentData()' );

        // cancel ongoing request
        this.authFlowVerificationPreVerifiedMembersWidgetService.cancel();

        // get status and service data
        const { status, data } = await this.authFlowVerificationPreVerifiedMembersWidgetService.fetchComponentData( {
            url: this.props.widget.url,
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    /**
     * @desc On member click, redirect to member management page.
     */
    handleOnClickAction( { id = null } ) {
        log.debug( 'AuthFlowVerificationPreVerifiedMembers.handleOnClickAction()' );

        // start calculating alerts
        this.globalService.startAlertsCalculation( { memberId: id, patientId: this.state.patientId } );

        // when `member` is clicked, redirect to member detail page
        this.props.history.push( {
            pathname: DASHBOARD_SUB_ROUTES.MEMBER_MANAGEMENT,
            state: { memberId: id }
        } );
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.authFlowVerificationPreVerifiedMembersWidgetService.cancel(); // cancel ongoing requests
        this.globalService.cancel();
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <AuthFlowVerificationPreVerifiedMembers
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                handleOnClickAction={ this.handleOnClickAction }
                { ...get( this.state, 'componentData', {} ) }
            />
        );
    }
}

// set display name
_AuthFlowVerificationPreVerifiedMembersWidget.displayName = 'AuthFlowVerificationPreVerifiedMembersWidget';

// set default props
_AuthFlowVerificationPreVerifiedMembersWidget.defaultProps = {};

// prop types
_AuthFlowVerificationPreVerifiedMembersWidget.propTypes = {};

// wrap component with router
export const AuthFlowVerificationPreVerifiedMembersWidget = withRouter( _AuthFlowVerificationPreVerifiedMembersWidget );
